import type { Lesson, LessonRecord, Group } from '@/hooks/useDashboardData';
import { formatDate } from '@/lib/date';

interface RecentRecordsProps {
  records: LessonRecord[];
  lessons: Lesson[];
  groups: Group[];
}

export default function RecentRecords({ records, lessons, groups }: RecentRecordsProps) {
  const recent = records.slice(0, 4);

  return (
    <div className="overflow-hidden rounded-xl border border-background-200 bg-white">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[560px] text-left text-sm">
          <thead>
            <tr className="border-b border-background-200 bg-background-100/60 text-xs text-foreground-500">
              <th className="px-4 py-3 font-semibold">Ders Adı</th>
              <th className="px-4 py-3 font-semibold">Grup</th>
              <th className="px-4 py-3 font-semibold">Tarih</th>
              <th className="px-4 py-3 font-semibold">İzlenme</th>
              <th className="px-4 py-3 text-right font-semibold">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {recent.map((r) => {
              const lesson = lessons.find((l) => l.id === r.lesson_id);
              const group = groups.find((g) => g.id === r.group_id);
              return (
                <tr key={r.id} className="border-b border-background-100 last:border-0 hover:bg-background-50">
                  <td className="px-4 py-3 font-medium text-foreground-900">{lesson?.title ?? r.title}</td>
                  <td className="px-4 py-3 text-foreground-600">{group?.name ?? '-'}</td>
                  <td className="px-4 py-3 text-foreground-600">{formatDate(r.date)}</td>
                  <td className="px-4 py-3">
                    <span className="inline-flex items-center gap-1 text-foreground-600">
                      <i className="ri-eye-line text-xs" /> {r.views}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <a
                      href={r.video_url}
                      target="_blank"
                      rel="noreferrer nofollow"
                      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700 transition hover:bg-primary-100"
                    >
                      <i className="ri-play-circle-line" /> İzle
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}